// (c) Copyright 2021 Justin Lloyd. All rights reserved.

export enum MovementDirection
{
    LeftToRight = 0,
    Right = 0,
    RightToLeft = 1,
    Left = 1,
    BottomToTop = 2,
    Up = 2,
    TopToBottom = 3,
    Down = 3
}

